import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import CountUp from "react-countup";
import { Link } from "react-router-dom";

const Expense = (param) => {
  const [chartData, setChartData] = useState([]);
  const [chartCategory, setChartCategory] = useState([]);
  const linechartcustomerColors = ["#FFAA00", "#f17171"];
  useEffect(() => {
    if (param.data && param.data["chartexpense"]) setChartData(param.data["chartexpense"]);
    if (param.data && param.data["chartexpensecategory"]) setChartCategory(param.data["chartexpensecategory"]);
  }, [param.data]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return (
    <React.Fragment>
      <Row>
        <Col xl={3} md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">PEMBELIAN MATERIAL</p>
                </div>
                <div className="flex-shrink-0">
                  <h5 className={"fs-14 mb-0 text-success"}>
                    <i className={"fs-13 align-middle ri-arrow-right-up-line"}></i> {100} %
                  </h5>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-2">
                <div>
                  <h4 className="fs-24 fw-semibold ff-secondary mb-3">
                    <span className="counter-value">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={(param.data && param.data["purchase_sum"]) ?? 0} decimals={0} duration={4} />
                    </span>
                  </h4>
                  <p className="m-0 p-0"><span className="text-info fs-15 text-bold"> {param.data && param.data["purchase_count"] ? param.data["purchase_count"] : 0}</span> transaksi</p>
                  <Link to="/purchase" className="text-decoration-underline">
                    <i className="ri-external-link-line"></i> Lihat Daftar Pembelian
                  </Link>
                </div>
                <div className="avatar-xs flex-shrink-0">
                  <span className={"avatar-title rounded fs-3 bg-warning"}>
                    <i className=" ri-shopping-cart-2-line"></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">BIAYA</p>
                </div>
                <div className="flex-shrink-0">
                  <h5 className={"fs-14 mb-0 text-success"}>
                    <i className={"fs-13 align-middle ri-arrow-right-up-line"}></i> {100} %
                  </h5>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-2">
                <div>
                  <h4 className="fs-24 fw-semibold ff-secondary mb-3">
                    <span className="counter-value">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={(param.data && param.data["expense_sum"]) ?? 0} decimals={0} duration={4} />
                    </span>
                  </h4>
                  <p className="m-0 p-0"><span className="text-info fs-15 text-bold"> {param.data && param.data["expense_count"] ? param.data["expense_count"] : 0}</span> transaksi</p>
                  <Link to="/acc-trans" className="text-decoration-underline">
                    <i className="ri-external-link-line"></i> Lihat Daftar Transaksi
                  </Link>
                </div>
                <div className="avatar-xs flex-shrink-0">
                  <span className={"avatar-title rounded fs-3 bg-warning"}>
                    <i className="bx bxs-coin-stack"></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">HUTANG MATERIAL</p>
                </div>
                <div className="flex-shrink-0">
                  <h5 className={"fs-14 mb-0 text-success"}>
                    <i className={"fs-13 align-middle ri-arrow-right-up-line"}></i> {100} %
                  </h5>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-2">
                <div>
                  <h4 className="fs-24 fw-semibold ff-secondary mb-3">
                    <span className="counter-value">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={(param.data && param.data["payable_sum"]) ?? 0} decimals={0} duration={4} />
                    </span>
                  </h4>
                  <p className="m-0 p-0"><span className="text-info fs-15 text-bold"> {param.data && param.data["payable_count"] ? param.data["payable_count"] : 0}</span> transaksi</p>
                  <Link to="/payable" className="text-decoration-underline">
                    <i className="ri-external-link-line"></i> Lihat Daftar Hutang
                  </Link>
                </div>
                <div className="avatar-xs flex-shrink-0">
                  <span className={"avatar-title rounded fs-3 bg-warning"}>
                    <i className="ri-bank-line"></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} md={6}>
          <Card className="card-animate">
            <CardBody>
              <div className="d-flex align-items-center">
                <div className="flex-grow-1 overflow-hidden">
                  <p className="text-uppercase fw-medium text-muted text-truncate mb-0">JATUH TEMPO DALAM 7 HARI</p>
                </div>
                <div className="flex-shrink-0">
                  <h5 className={"fs-14 mb-0 text-success"}>
                    <i className={"fs-13 align-middle ri-arrow-right-up-line"}></i> {100} %
                  </h5>
                </div>
              </div>
              <div className="d-flex align-items-end justify-content-between mt-2">
                <div>
                  <h4 className="fs-24 fw-semibold ff-secondary mb-3">
                    <span className="counter-value">
                      <CountUp start={0} prefix="Rp" suffix={""} separator="." end={(param.data && param.data["payable_due_sum"]) ?? 0} decimals={0} duration={4} />
                    </span>
                  </h4>
                  <p className="m-0 p-0"><span className="text-info fs-15 text-bold"> {param.data && param.data["payable_due_count"] ? param.data["payable_due_count"] : 0}</span> transaksi</p>
                  <Link to="/payable" className="text-decoration-underline">
                    <i className="ri-external-link-line"></i> Lihat Daftar Hutang
                  </Link>
                </div>
                <div className="avatar-xs flex-shrink-0">
                  <span className={"avatar-title rounded fs-3 bg-warning"}>
                    <i className="ri-time-line"></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <Card className="">
            <CardHeader className="border-0 align-items-center d-flex">
              <h4 className="card-title mb-0 flex-grow-1">GRAFIK PENGELUARAN</h4>
              {/* <div className="d-flex gap-1">
            <button type="button" className="btn btn-soft-secondary btn-sm" onClick={() => { onChangeChartPeriod("all"); }}>
              ALL
            </button>
            <button type="button" className="btn btn-soft-secondary btn-sm" onClick={() => { onChangeChartPeriod("month"); }}>
              1M
            </button>
            <button type="button" className="btn btn-soft-secondary btn-sm" onClick={() => { onChangeChartPeriod("halfyear"); }}>
              6M
            </button>
            <button type="button" className="btn btn-soft-primary btn-sm" onClick={() => { onChangeChartPeriod("year"); }}>
              1Y
            </button>
          </div> */}
            </CardHeader>

            <CardBody className="p-0 pb-2">
              <div dir="ltr">
                <ReactApexChart
                  options={{
                    chart: {
                      height: 680,
                      type: 'bar',
                      toolbar: {
                        show: false,
                      }
                    },
                    plotOptions: {
                      bar: {
                        horizontal: false,
                        columnWidth: '45%',
                        endingShape: 'rounded'
                      },
                    },
                    dataLabels: {
                      enabled: false
                    },
                    stroke: {
                      show: true,
                      width: 2,
                      colors: ['transparent']
                    },
                    colors: linechartcustomerColors,
                    xaxis: {
                      categories: chartCategory,
                    },
                    yaxis: {
                      labels: {
                        formatter: function (value) {
                          return `Rp ${currencyFormat(value)}`;
                        }
                      },
                    },
                    grid: {
                      borderColor: '#f1f1f1',
                    },
                    fill: {
                      opacity: 1

                    },
                    tooltip: {
                      theme: 'dark',
                      fillSeriesColor: true,
                      y: [
                        {
                          formatter: function (y) {
                            if (typeof y !== "undefined") {
                              return `Rp ${currencyFormat(y)}`;
                            }
                            return y;
                          },
                        },
                        {
                          formatter: function (y) {
                            if (typeof y !== "undefined") {
                              return `Rp ${currencyFormat(y)}`;
                            }
                            return y;
                          },
                        },
                        {
                          formatter: function (y) {
                            if (typeof y !== "undefined") {
                              return `Rp ${currencyFormat(y)}`;
                            }
                            return y;
                          },
                        },
                        {
                          formatter: function (y) {
                            if (typeof y !== "undefined") {
                              return `Rp ${currencyFormat(y)}`;
                            }
                            return y;
                          },
                        },
                        {
                          formatter: function (y) {
                            if (typeof y !== "undefined") {
                              return `Rp ${currencyFormat(y)}`;
                            }
                            return y;
                          },
                        },
                        {
                          formatter: function (y) {
                            if (typeof y !== "undefined") {
                              return `Rp ${currencyFormat(y)}`;
                            }
                            return y;
                          },
                        },
                      ],
                    },
                  }}
                  series={chartData}
                  type="bar"
                  height="680"
                  className="apex-charts" />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Expense;
